
import { DropDown, Input } from '../controls';
import { DataContext } from '../../data/DataContext';
import { typeDocument, sex } from '../../data/MochaData';
import { useContext } from 'react';

const Step1 = () => {
    const { CVS, setCVS, changeHandler } = useContext(DataContext);

    const onChange = (property: string, value: string) => {
        setCVS({ ...CVS, [property]: value });
    }

    return (
        <div className="step-cvs">
            <div className="step-container-cvs">
                <div className="lbl-paso-t1 mt10">
                    <span className="">Detalles personales</span>
                </div>
                <div className="mt-10">
                    <span className="lbl-paso-t2">(*) Espacios requeridos</span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="lbl-paso-t3">Antes de iniciar queremos validar información para cotizar tu Seguro de Vida </span>
                </div>
                <DropDown
                    label='Tipo de identificación*'
                    dataProvider={typeDocument}
                    valueSelect={CVS.tipoIdentificacion}
                    field='tipoIdentificacion'
                    onChangeSelect={onChange}
                />
                {CVS.tipoIdentificacion == '1' &&
                    <Input
                        id='identificacion'
                        label='Número de identificación*'
                        value={CVS.identificacion}
                        field='identificacion'
                        onChange={changeHandler}
                        placeholder="Identificación"
                        cssClassStyle=''
                        type='mask'
                        mask="999-999999-9999a"
                        pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w"
                        title="Documento invalido"
                    />
                }
                {CVS.tipoIdentificacion != '1' &&
                    <Input
                        id='identificacion'
                        label='Número de identificación*'
                        value={CVS.identificacion}
                        field='identificacion'
                        onChange={changeHandler}
                        placeholder="Identificación"
                        cssClassStyle=''
                    />
                }
                <Input
                    id='nombre1'
                    label='Nombres*'
                    value={CVS.nombre1}
                    field='nombre1'
                    onChange={changeHandler}
                    placeholder="Primer Nombre"
                    cssClassStyle=''
                />
                <Input
                    id='nombre2'
                    label='Nombres*'
                    value={CVS.nombre2}
                    field='nombre2'
                    onChange={changeHandler}
                    onlyInput={true}
                    placeholder="Segundo Nombre"
                    cssClassStyle=''
                />
                <Input
                    id='apellido1'
                    label='Apellidos*'
                    value={CVS.apellido1}
                    field='apellido1'
                    onChange={changeHandler}
                    placeholder="Primer Apellido"
                    cssClassStyle=''
                />
                <Input
                    id='apellido2'
                    label='Nombres*'
                    value={CVS.apellido2}
                    field='apellido2'
                    onChange={changeHandler}
                    onlyInput={true}
                    placeholder="Segundo Apellido"
                    cssClassStyle=''
                />
                <DropDown
                    label='Sexo*'
                    dataProvider={sex}
                    valueSelect={CVS.sexo}
                    field='sexo'
                    onChangeSelect={onChange}
                />
            </div>
        </div>
    );
}

export { Step1 };